import React, { useEffect, useState } from 'react';
import { requiredUpdateForDriver, startRequiredUpdate } from '../utils/requiredUpdate';
import { useLanguage } from '../i18n/LanguageContext';

export default function RequiredUpdateGate({ notice, activeRide, rideOfferOpen }) {
  const { t } = useLanguage();
  const [update, setUpdate] = useState(null);
  const [openingPlay, setOpeningPlay] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (activeRide || rideOfferOpen) {
      setUpdate(null);
      return () => { cancelled = true; };
    }
    requiredUpdateForDriver(notice)
      .then((next) => { if (!cancelled) setUpdate(next); })
      .catch(() => { if (!cancelled) setUpdate(null); });
    return () => { cancelled = true; };
  }, [notice, activeRide?.id, rideOfferOpen]);

  if (!update) return null;

  const openUpdate = async () => {
    setOpeningPlay(true);
    await startRequiredUpdate();
    setOpeningPlay(false);
  };

  return (
    <div className="required-update-gate" role="dialog" aria-modal="true" aria-labelledby="required-update-title">
      <section className="required-update-card">
        <div className="required-update-icon" aria-hidden="true">↑</div>
        <span className="required-update-eyebrow">MYTOWNLY ANNA</span>
        <h1 id="required-update-title">{update.title}</h1>
        <p>{update.message}</p>
        <div className="required-update-version">
          {t('requiredUpdate.versionLine', { version: update.minimumVersion })}
        </div>
        <button type="button" className="btn btn-green required-update-button" onClick={openUpdate} disabled={openingPlay}>
          {openingPlay ? t('requiredUpdate.opening') : t('requiredUpdate.updateNow')}
        </button>
        <small>{t('requiredUpdate.idleNote')}</small>
      </section>
    </div>
  );
}
